var render = function render(_c,_vm){return _c(_vm.props.tag,_vm._b({tag:"compontent",class:['fact-item', _vm.data.class, _vm.data.staticClass, 'font-spacing-1'],style:(_vm.data.style),attrs:{"id":_vm.data.id}},'compontent',_vm.data.attrs,false),[_c('c-eyecatcher-icon',{attrs:{"iconName":_vm.props.iconName,"iconVariant":_vm.props.iconVariant,"iconSize":_vm.props.iconSize}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }